// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__+nPRX","content":"Layout_content__UOgH6"};